import { useMemo, useRef, useState } from 'react'
export function clearHelpStorage(scope?: string) { try { for (const key of Object.keys(sessionStorage)) if (key.startsWith(scope ? `web-help:${scope}:` : 'web-help:')) sessionStorage.removeItem(key) } catch { /* Storage can be unavailable. */ } }
export function useHelpDraft(scope: string) {
  const key = `web-help:${scope}:draft`
  const [value, setValue] = useState(() => { try { return sessionStorage.getItem(key) || '' } catch { return '' } })
  return [value, (next: string) => { setValue(next); try { if (next) sessionStorage.setItem(key, next); else sessionStorage.removeItem(key) } catch { /* Preserve in memory. */ } }] as const
}
export function useHelpIntent(scope: string) {
  const intent = useRef<{ payload: string; key: string } | null>(null)
  return useMemo(() => {
    const storageKey = `web-help:${scope}:intent`
    return {
      key(payload: unknown) {
        const serialized = JSON.stringify(payload)
        if (!intent.current) { try { const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null') as { payload: string; key: string } | null; if (saved && typeof saved.payload === 'string' && typeof saved.key === 'string') intent.current = saved } catch { /* Keep in-memory recovery. */ } }
        if (intent.current?.payload !== serialized) { intent.current = { payload: serialized, key: `help-${crypto.randomUUID()}` }; try { sessionStorage.setItem(storageKey, JSON.stringify(intent.current)) } catch { /* Keep in-memory recovery. */ } }
        return intent.current.key
      },
      complete() { intent.current = null; try { sessionStorage.removeItem(storageKey) } catch { /* Next in-memory intent still rotates. */ } },
    }
  }, [scope])
}
